export default () => {
	const languageItems = document.querySelectorAll('.language__button'),
		languageCurrent = document.querySelector('.language__current');

	if(!languageItems) return;

	for (const languageItem of languageItems) {
		languageItem.addEventListener('click', function () {
			let thisLanguage = this.textContent;
			languageCurrent.textContent = '';
			languageItems.forEach(item => {
				item.classList.remove('active');
				item.closest('li').classList.remove('active');
			})
			this.closest('li').classList.add('active');
			this.classList.add('active');
			languageCurrent.textContent = thisLanguage;
			this.closest('.header__language').classList.remove('open');
		})
	}

	languageCurrent.addEventListener('click', function () {
		this.closest('.header__language').classList.toggle('open');
	});

	window.addEventListener('click', function(e){
		if (document.querySelector('.header__language').contains(e.target)){
			return;
		} else{
			document.querySelector('.header__language').classList.remove('open');
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/select-language.js